import { render, staticRenderFns } from "./UADashboard1.vue?vue&type=template&id=6fbec3b5"
import script from "./UADashboard1.vue?vue&type=script&lang=js"
export * from "./UADashboard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports